import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * GiftCardsOrderApi - axios parameter creator
 * @export
 */
const GiftCardsOrderApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary The issued cards, paged, sorted and filtered in SQL on the token\'s json names (BW-8409; it used to load the whole table with five tracked includes). `ramn` is the booked balance: what is left after placed orders. (Auth roles: System)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (loadOptions, options = {}) => {
            const localVarPath = `/v1/GiftCardsOrder/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (loadOptions !== undefined) {
                for (const [key, value] of Object.entries(loadOptions)) {
                    localVarQueryParameter[key] = value;
                }
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiftCardHistory: async (id, options = {}) => {
            const localVarPath = `/v1/GiftCardsOrder/GetGiftCardHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary The card, the recipient it was issued for, and the image their e-mail shows. (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiftCardNotificationDetails: async (id, options = {}) => {
            const localVarPath = `/v1/GiftCardsOrder/GetGiftCardNotificationDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiftCardOrderEvents: async (id, options = {}) => {
            const localVarPath = `/v1/GiftCardsOrder/GetGiftCardOrderEvents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * GiftCardsOrderApi - functional programming interface
 * @export
 */
const GiftCardsOrderApiFp = function (configuration) {
    const localVarAxiosParamCreator = GiftCardsOrderApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary The issued cards, paged, sorted and filtered in SQL on the token\'s json names (BW-8409; it used to load the whole table with five tracked includes). `ramn` is the booked balance: what is left after placed orders. (Auth roles: System)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(loadOptions, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(loadOptions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GiftCardsOrderApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGiftCardHistory(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGiftCardHistory(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GiftCardsOrderApi.getGiftCardHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary The card, the recipient it was issued for, and the image their e-mail shows. (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGiftCardNotificationDetails(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGiftCardNotificationDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GiftCardsOrderApi.getGiftCardNotificationDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGiftCardOrderEvents(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGiftCardOrderEvents(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GiftCardsOrderApi.getGiftCardOrderEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * GiftCardsOrderApi - factory interface
 * @export
 */
const GiftCardsOrderApiFactory = function (configuration, basePath, axios) {
    const localVarFp = GiftCardsOrderApiFp(configuration);
    return {
        /**
         *
         * @summary The issued cards, paged, sorted and filtered in SQL on the token\'s json names (BW-8409; it used to load the whole table with five tracked includes). `ramn` is the booked balance: what is left after placed orders. (Auth roles: System)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(loadOptions, options) {
            return localVarFp.getAll(loadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiftCardHistory(id, options) {
            return localVarFp.getGiftCardHistory(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary The card, the recipient it was issued for, and the image their e-mail shows. (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiftCardNotificationDetails(id, options) {
            return localVarFp.getGiftCardNotificationDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiftCardOrderEvents(id, options) {
            return localVarFp.getGiftCardOrderEvents(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * GiftCardsOrderApi - object-oriented interface
 * @export
 * @class GiftCardsOrderApi
 * @extends {BaseAPI}
 */
class GiftCardsOrderApi extends BaseAPI {
    /**
     *
     * @summary The issued cards, paged, sorted and filtered in SQL on the token\'s json names (BW-8409; it used to load the whole table with five tracked includes). `ramn` is the booked balance: what is left after placed orders. (Auth roles: System)
     * @param {DataSourceLoadOptions} [loadOptions]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GiftCardsOrderApi
     */
    getAll(loadOptions, options) {
        return GiftCardsOrderApiFp(this.configuration).getAll(loadOptions, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GiftCardsOrderApi
     */
    getGiftCardHistory(id, options) {
        return GiftCardsOrderApiFp(this.configuration).getGiftCardHistory(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary The card, the recipient it was issued for, and the image their e-mail shows. (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GiftCardsOrderApi
     */
    getGiftCardNotificationDetails(id, options) {
        return GiftCardsOrderApiFp(this.configuration).getGiftCardNotificationDetails(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GiftCardsOrderApi
     */
    getGiftCardOrderEvents(id, options) {
        return GiftCardsOrderApiFp(this.configuration).getGiftCardOrderEvents(id, options).then((request) => request(this.axios, this.basePath));
    }
}

export { GiftCardsOrderApi, GiftCardsOrderApiAxiosParamCreator, GiftCardsOrderApiFactory, GiftCardsOrderApiFp };
//# sourceMappingURL=gift-cards-order-api.js.map
